(() => {
  const SELECTOR = '[data-ec-search]';

  const init = () => {
    const layer = document.querySelector(SELECTOR);
    if (!layer || layer.dataset.ecSearchReady === 'true') return;

    layer.dataset.ecSearchReady = 'true';

    const input = layer.querySelector('[data-ec-search-input]');
    const form = layer.querySelector('[data-ec-search-form]');
    const start = layer.querySelector('[data-ec-search-start]');
    const resultsWrap = layer.querySelector('[data-ec-search-results-wrap]');
    const results = layer.querySelector('[data-ec-search-results]');
    const loading = layer.querySelector('[data-ec-search-loading]');
    const clearButton = layer.querySelector('[data-ec-search-clear]');
    const status = layer.querySelector('[data-ec-search-status]');
    let timer = null;
    let controller = null;
    let lastQuery = '';

    const setStatus = (message = '') => {
      if (status) status.textContent = message;
    };


    const normalizeText = (value = '') => value
      .toLocaleLowerCase('it-IT')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\p{L}\p{N}]+/gu, ' ')
      .trim()
      .replace(/\s+/g, ' ');

    const INTERNAL_SEARCH_PATHS = [
      '/pages/evs-dashboard'
    ];

    const isInternalSearchResult = (node) => {
      const href = (node?.getAttribute?.('href') || '').toLocaleLowerCase('it-IT');
      const title = normalizeText(node?.dataset?.ecTitle || node?.textContent || '');

      return INTERNAL_SEARCH_PATHS.some(path => href.includes(path))
        || title === 'evs dashboard'
        || title.startsWith('evs dashboard ');
    };

    const isEvsIntent = (query = '') => {
      const q = normalizeText(query);
      if (!q) return false;

      const exactOrPrefix = q === 'evs' || q.startsWith('evs ');
      const commercialPhrases = [
        'evs pro',
        'video social',
        'video ai',
        'video social ai',
        'spot social',
        'spot ai',
        'spot pubblicitario',
        'video pubblicitario',
        'creare video social',
        'creare video ai'
      ];

      return exactOrPrefix || commercialPhrases.some(phrase => q.includes(phrase));
    };

    const cleanupInternalResults = () => {
      if (!results) return;

      results.querySelectorAll('[data-ec-search-result]').forEach(node => {
        if (isInternalSearchResult(node)) node.remove();
      });

      // Elimina gruppi diventati vuoti dopo la rimozione di risultati interni.
      results.querySelectorAll('.ec-search-group').forEach(group => {
        if (!group.querySelector('[data-ec-search-result]')) group.remove();
      });
    };

    const ensureEvsCommercialResult = (query) => {
      if (!results || !isEvsIntent(query)) return;

      // Se Shopify restituisce già EVS PRO, non duplichiamo il risultato.
      const existing = results.querySelector(
        'a[href*="/products/evs-pro-video-social-ai-15s"], [data-ec-evs-product-result]'
      );
      if (existing) return;

      const sourceTemplate = document.querySelector('[data-ec-evs-search-template]');
      const card = sourceTemplate?.content?.firstElementChild?.cloneNode(true);
      if (!card) return;

      let fragment = results.querySelector('.ec-search-results-fragment');
      if (!fragment) {
        fragment = document.createElement('div');
        fragment.className = 'ec-search-results-fragment';
        fragment.dataset.ecSearchCount = '0';
        results.replaceChildren(fragment);
      }

      fragment.querySelector('.ec-search-empty')?.remove();

      let grid = fragment.querySelector('.ec-search-result-grid');
      if (!grid) {
        const group = document.createElement('section');
        group.className = 'ec-search-group';
        group.innerHTML = `
          <div class="ec-search-group__head">
            <span>RISULTATI</span>
            <h3>Servizi, prodotti e offerte</h3>
          </div>
          <div class="ec-search-result-grid"></div>
        `;
        fragment.prepend(group);
        grid = group.querySelector('.ec-search-result-grid');
      }

      grid.prepend(card);
    };

    const refreshVisibleResultCount = () => {
      if (!results) return 0;

      const fragment = results.querySelector('.ec-search-results-fragment');
      const count = results.querySelectorAll('[data-ec-search-result]').length;

      if (fragment) fragment.dataset.ecSearchCount = String(count);

      if (!count && fragment && !fragment.querySelector('.ec-search-empty')) {
        fragment.innerHTML = `
          <div class="ec-search-empty">
            <span class="ec-search-empty__icon" aria-hidden="true">⌕</span>
            <span class="ec-search-result__badge">NESSUN RISULTATO</span>
            <h3>Non l'ho trovato con queste parole.</h3>
            <p>Prova con un termine più semplice oppure raccontaci direttamente cosa devi fare.</p>
            <a href="/pages/contatti?aiutami=scegliere">Aiutami a scegliere →</a>
          </div>
        `;
      }

      return count;
    };

    const kindWeight = {
      ECOSISTEMA: 520,
      SERVIZIO: 470,
      OFFERTA: 390,
      DEAL: 380,
      IMPORTER: 370,
      MARKETPLACE: 250,
      PRODOTTO: 220,
      PAGINA: 160,
      GUIDA: 145,
      COLLEZIONE: 130
    };

    const resultScore = (node, query) => {
      const q = normalizeText(query);
      const title = normalizeText(node?.dataset?.ecTitle || '');
      const kind = (node?.dataset?.ecKind || '').toUpperCase();

      if (!q || !title) return kindWeight[kind] || 0;

      const coreTitle = title.replace(/^eccomi\s+/, '');
      const qTokens = q.split(' ').filter(Boolean);
      const titleTokens = title.split(' ').filter(Boolean);

      let score = kindWeight[kind] || 0;

      // ECCOMI exact intent: "performance" => "ECCOMI PERFORMANCE"
      if (coreTitle === q) score += 2600;
      if (title === q) score += 2500;

      // Strong textual relevance
      if (coreTitle.startsWith(q)) score += 1450;
      else if (title.startsWith(q)) score += 1350;

      const position = title.indexOf(q);
      if (position >= 0) {
        score += Math.max(0, 1050 - Math.min(position, 120) * 10);
      }

      // All words present
      const allTokensPresent = qTokens.every(token => titleTokens.some(word => word.includes(token)));
      if (allTokensPresent) score += 260;

      // Word-prefix matching helps "iphone" rank real iPhone titles above accessories
      qTokens.forEach(token => {
        const firstWordIndex = titleTokens.findIndex(word => word.startsWith(token));
        if (firstWordIndex >= 0) score += Math.max(40, 260 - firstWordIndex * 28);
      });

      // Exact ecosystem/service intent should beat incidental product text
      if ((kind === 'ECOSISTEMA' || kind === 'SERVIZIO') && (coreTitle === q || coreTitle.startsWith(q))) {
        score += 900;
      }

      return score;
    };

    const sortContainer = (container, query) => {
      if (!container) return;
      const items = Array.from(container.querySelectorAll(':scope > [data-ec-smart-result]'));
      if (items.length < 2) return;

      items
        .map((node, index) => ({
          node,
          index,
          score: resultScore(node, query)
        }))
        .sort((a, b) => (b.score - a.score) || (a.index - b.index))
        .forEach(item => container.appendChild(item.node));
    };

    const applySmartRanking = (query) => {
      if (!results) return;

      // Rank cards within each visual group first.
      results.querySelectorAll('.ec-search-result-grid, .ec-search-link-list').forEach(container => {
        sortContainer(container, query);
      });

      // Then rank whole groups by their strongest result.
      const fragment = results.querySelector('.ec-search-results-fragment');
      if (!fragment) return;

      const groups = Array.from(fragment.querySelectorAll(':scope > .ec-search-group'));
      if (groups.length < 2) return;

      groups
        .map((group, index) => {
          const childScores = Array.from(group.querySelectorAll('[data-ec-smart-result]'))
            .map(node => resultScore(node, query));

          return {
            group,
            index,
            score: childScores.length ? Math.max(...childScores) : 0
          };
        })
        .sort((a, b) => (b.score - a.score) || (a.index - b.index))
        .forEach(item => fragment.appendChild(item.group));
    };

    const closeOtherLayers = () => {
      const switcher = document.getElementById('EccomiSwitcherToggle');
      const siteMenu = document.getElementById('EccomiSiteMenuToggle');
      if (switcher) switcher.checked = false;
      if (siteMenu) siteMenu.checked = false;
    };

    const open = () => {
      closeOtherLayers();
      layer.hidden = false;
      layer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ec-search-open');
      window.setTimeout(() => input?.focus({ preventScroll: true }), 60);
    };

    const close = () => {
      layer.hidden = true;
      layer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ec-search-open');
      setStatus('');
    };

    const resetResults = () => {
      lastQuery = '';
      if (controller) controller.abort();
      if (results) results.innerHTML = '';
      if (resultsWrap) resultsWrap.hidden = true;
      if (start) start.hidden = false;
      if (loading) loading.hidden = true;
      clearButton.hidden = !(input?.value || '').length;
      setStatus('');
    };

    const showLoading = () => {
      if (start) start.hidden = true;
      if (resultsWrap) resultsWrap.hidden = false;
      if (results) results.innerHTML = '';
      if (loading) loading.hidden = false;
      setStatus('Ricerca in corso');
    };

    const renderError = () => {
      if (loading) {
        loading.hidden = true;
        loading.setAttribute('hidden', '');
      }
      if (!results) return;
      results.innerHTML = `
        <div class="ec-search-empty">
          <span class="ec-search-empty__icon" aria-hidden="true">!</span>
          <span class="ec-search-result__badge">RICERCA NON DISPONIBILE</span>
          <h3>Non riesco a cercare in questo momento.</h3>
          <p>Puoi comunque raccontarci direttamente cosa devi fare.</p>
          <a href="/pages/contatti?aiutami=scegliere">Aiutami a scegliere →</a>
        </div>`;
      setStatus('Ricerca temporaneamente non disponibile');
    };

    const search = async (query) => {
      const q = query.trim();
      clearButton.hidden = !q.length;

      if (q.length < 2) {
        resetResults();
        return;
      }

      if (q === lastQuery) return;
      lastQuery = q;

      if (controller) controller.abort();
      controller = new AbortController();
      showLoading();

      const route = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      const params = new URLSearchParams({
        q,
        section_id: 'eccomi-search-results',
        'resources[type]': 'product,page,article,collection',
        'resources[limit]': '8',
        'resources[options][unavailable_products]': 'last'
      });

      try {
        const response = await fetch(`${route}?${params.toString()}`, {
          signal: controller.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error(`Search ${response.status}`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('#shopify-section-eccomi-search-results');
        const fragment = section?.innerHTML || html;

        if (loading) {
          loading.hidden = true;
          loading.setAttribute('hidden', '');
        }
        if (results) {
          results.innerHTML = fragment;
          cleanupInternalResults();
          ensureEvsCommercialResult(q);
          applySmartRanking(q);
        }

        const count = refreshVisibleResultCount();
        setStatus(count ? `${count} risultati trovati` : 'Nessun risultato trovato');
      } catch (error) {
        if (error?.name === 'AbortError') return;
        renderError();
      }
    };

    const schedule = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => search(input?.value || ''), 180);
    };

    document.addEventListener('click', (event) => {
      const openTrigger = event.target.closest('[data-ec-search-open]');
      if (openTrigger) {
        event.preventDefault();
        open();
        return;
      }

      const closeTrigger = event.target.closest('[data-ec-search-close]');
      if (closeTrigger && layer.contains(closeTrigger)) {
        event.preventDefault();
        close();
        return;
      }

      const queryButton = event.target.closest('[data-ec-search-query]');
      if (queryButton && layer.contains(queryButton)) {
        event.preventDefault();
        input.value = queryButton.dataset.ecSearchQuery || '';
        clearButton.hidden = !input.value.length;
        input.focus();
        search(input.value);
      }
    });

    input?.addEventListener('input', schedule);

    clearButton?.addEventListener('click', () => {
      input.value = '';
      input.focus();
      resetResults();
    });

    form?.addEventListener('submit', (event) => {
      const q = (input?.value || '').trim();
      if (!q) {
        event.preventDefault();
        input?.focus();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !layer.hidden) {
        event.preventDefault();
        close();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();